import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["component", "size", "classes", "sourceUrl", "fallbackUrl", "fallbackIcon", "iconColor"];
var ICON_COLOR = {
  'none': 'none',
  'default': 'default',
  'error': 'error',
  'warning': 'warning',
  'success': 'success',
  'info': 'info',
  'secondary': 'secondary'
};
var useStyles = makeStyles(function (theme) {
  var _ref;

  var xl = theme.spacing(16);
  var lg = theme.spacing(10);
  var md = theme.spacing(7);
  var sm = theme.spacing(4);
  var xs = theme.spacing(3);
  return _ref = {
    xl: {
      height: xl,
      width: xl
    },
    lg: {
      height: lg,
      width: lg
    },
    md: {
      height: md,
      width: md
    },
    sm: {
      height: sm,
      width: sm
    },
    xs: {
      height: xs,
      width: xs
    }
  }, _ref[ICON_COLOR.none] = {
    // none
    backgroundColor: 'transparent',
    color: '#ddd'
  }, _ref[ICON_COLOR["default"]] = {
    // default
    backgroundColor: '#F5F5F5',
    color: get(theme, 'palette.action.disabled')
  }, _ref[ICON_COLOR.error] = {
    // error
    backgroundColor: '#F4433614',
    color: get(theme, 'palette.error.main')
  }, _ref[ICON_COLOR.warning] = {
    // warning
    backgroundColor: '#ED6C0214',
    color: get(theme, 'palette.warning.main')
  }, _ref[ICON_COLOR.success] = {
    // success
    backgroundColor: '#587F1B14',
    color: get(theme, 'palette.success.main')
  }, _ref[ICON_COLOR.info] = {
    // info
    backgroundColor: '#2196F314',
    color: get(theme, 'palette.info.dark')
  }, _ref[ICON_COLOR.secondary] = {
    // secondary
    backgroundColor: '#745CA114',
    color: get(theme, 'palette.secondary.main')
  }, _ref;
});
var DEFAULT_AVATAR_PROPS = {
  variant: 'square',
  alt: 'avatar'
};

var AvatarWithFallback = function AvatarWithFallback(_ref2) {
  var _ref2$component = _ref2.component,
      Component = _ref2$component === void 0 ? Avatar : _ref2$component,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "md" : _ref2$size,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? {} : _ref2$classes,
      sourceUrl = _ref2.sourceUrl,
      fallbackUrl = _ref2.fallbackUrl,
      fallbackIcon = _ref2.fallbackIcon,
      _ref2$iconColor = _ref2.iconColor,
      iconColor = _ref2$iconColor === void 0 ? ICON_COLOR.none : _ref2$iconColor,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var classNames = useStyles();
  return /*#__PURE__*/React.createElement(Component, _extends({}, DEFAULT_AVATAR_PROPS, rest, {
    classes: _extends({
      root: classNames[size],
      colorDefault: classNames[iconColor]
    }, classes),
    src: sourceUrl
  }), fallbackIcon || /*#__PURE__*/React.createElement(Component, _extends({}, DEFAULT_AVATAR_PROPS, rest, {
    classes: _extends({
      root: classNames[size],
      colorDefault: classNames.colorDefault
    }, classes),
    src: fallbackUrl
  }), "\xA0"));
};

AvatarWithFallback.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  component: PropTypes.elementType,
  classes: PropTypes.object,
  sourceUrl: PropTypes.string,
  fallbackUrl: PropTypes.string,
  fallbackIcon: PropTypes.node,
  iconColor: PropTypes.oneOf(Object.keys(ICON_COLOR))
};

export { ICON_COLOR, AvatarWithFallback as default };
//# sourceMappingURL=index.module.js.map
